"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientTest = ClientTest;
const react_1 = require("react");
function ClientTest() {
    (0, react_1.useEffect)(() => {
        console.log("ClientTest component mounted");
    }, []);
    return null;
}
